import * as React from "react";
const VisibilityIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#655C68"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.576 8.713c-.136-.215-.204-.323-.242-.49a1.173 1.173 0 0 1 0-.446c.038-.167.106-.275.242-.49C2.702 5.505 6.052 1 11.156 1c5.106 0 8.455 4.505 9.58 6.287.137.215.205.323.243.49a1.17 1.17 0 0 1 0 .446c-.038.167-.106.275-.242.49C19.612 10.495 16.262 15 11.157 15s-8.455-4.505-9.58-6.287Z"
    />
    <path
      stroke="#655C68"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.157 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    />
  </svg>
);
export default VisibilityIcon;
